import { Button } from "../../../../components/ui";
import { handleEvaluationButtonClick } from "../../../../utils/redirectToNewReview";

const ShareExperienceBlock = () => {
  return (
    <div className="text-center py-14 px-4 bg-gray mt-4 lg:mt-12">
      <h2 className="mb-4">Prêt(e) à partager votre expérience ?</h2>
      <p className="mb-4 lg:mb-8">
        Aidez les autres conducteurs à faire le bon choix. Votre avis ne prend
        que 2 minutes.
      </p>
      <Button
        size="lg"
        onClick={() =>
          handleEvaluationButtonClick({
            page_type: "Bloc partager son expérience",
          })
        }
      >
        Évaluer mon véhicule en 2 minutes
      </Button>
    </div>
  );
};

export default ShareExperienceBlock;
